"use strict";
// @ts-ignore
try {
    self['workbox:strategies:6.5.1'] && _();
}
catch (e) { }
